// Pesos para DV1 (12 posições) e DV2 (13 posições) — IN RFB 2.229/2024
const WEIGHT_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHT_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function sumCnpj(weights, chars) {
  return chars.reduce(
    (acc, c, i) => acc + (c.charCodeAt(0) - 48) * weights[i],
    0
  );
}

function calcDv(segment, weights) {
  const remainder = 11 - (sumCnpj(weights, segment.split("")) % 11);
  return remainder > 9 ? 0 : remainder;
}

export default function isValidCnpj(value) {
  if (!value) return false;
  // Remove separadores de máscara e normaliza para uppercase
  const clean = value.replace(/[.\-/\s]/g, "").toUpperCase();
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(clean)) return false;
  if (/^(.)\1{13}$/.test(clean)) return false;
  const dv1 = calcDv(clean.slice(0, 12), WEIGHT_DV1);
  const dv2 = calcDv(clean.slice(0, 13), WEIGHT_DV2);
  return dv1 === Number(clean[12]) && dv2 === Number(clean[13]);
}
